'use client';

import { useT } from '@/i18n/client';
import { OPEN_COOKIE_SETTINGS } from './CookieConsent';

/** Footer link that re-opens the cookie preference centre after first choice. */
export function CookieSettingsLink() {
  const t = useT();
  return (
    <button
      type="button"
      className="vn-footer__cookiebtn"
      onClick={() => window.dispatchEvent(new Event(OPEN_COOKIE_SETTINGS))}
    >
      {t('footer.cookieSettings')}
    </button>
  );
}
